import FinanceVersionList from '@/views/finance-version/FinanceVersionList.vue';
import VersionEditor from '@/views/finance-version/VersionEditor.vue';
import { HistoryOutlined } from '@ant-design/icons-vue';

export const financeVersionRoutes = [
    {
        path: 'finance-version',
        name: 'FinanceVersionList',
        meta: {
            title: '版本列表',
            icon: HistoryOutlined
        },
        children: [
            {
                path: '',
                component: FinanceVersionList,
                name: 'FinanceVersionList',
                meta: {
                    title: '版本列表'
                }
            },
            {
                path: 'create',
                component: VersionEditor,
                name: 'FinanceVersionCreate',
                meta: {
                    title: '新增版本',
                    hideInMenu: true,
                    hidePageChrome: true
                }
            },
            {
                path: 'edit/:id',
                component: VersionEditor,
                name: 'FinanceVersionEdit',
                meta: {
                    title: '編輯版本',
                    hideInMenu: true,
                    hidePageChrome: true
                }
            },
            {
                path: 'view/:id',
                component: VersionEditor,
                name: 'FinanceVersionView',
                meta: {
                    title: '查看版本',
                    hideInMenu: true,
                    hidePageChrome: true
                }
            }
        ]
    }
];
